export interface Subscription {
  active: boolean;
  plan: SubscriptionPlan;
  monthlyPayment: number;
  totalPayedAmount: number;
  totalBalance: number;
  nextBillingDate: string;
  scheduledForCancellation: boolean;
  payedPeriods: PayedPeriod[];
  isFreePlan: boolean;
}

export interface ExtendedSubscription {
  name: SubscriptionPlan;
  isPrivate: null | boolean;
  sortOrder: string;
  type: "Free" | "Regular";
  freePeriods: number;
  periodDuration: number;
  payment: number;
  stripeId: null;
  featuresTitle: string;
  features: string[];
  partitionKey: string;
  id: string;
  stripeName: string;
}

export interface PayedPeriod {
  invoiceId: string;
  startDate: string;
  endDate: string;
}

export type SubscriptionPlan = SubscriptionPlanName | null;
export enum SubscriptionPlanName {
  Starter = "Starter",
  MySocial = "MySocial",
  MySocialMyFans = "MySocialMyFans",
  Free = "Free",
}

export interface PaymentHistory {
  invoiceId: string;
  date: string;
  amount: number;
  success: boolean;
  errorCode: string;
  failedMessage: string;
}

export interface buyMessagesOption {
  stripeId: string;
};

export interface MessageOption {
  name: string;
  stripeId: string;
  cost: number;
  messageCount: number;
}

export type PostsOption = {
  name: string;
  postCount: number;
  cost: number;
};
